import { render, staticRenderFns } from "./reportNoticeConfig.vue?vue&type=template&id=700d23ce&scoped=true"
import script from "./reportNoticeConfig.vue?vue&type=script&lang=js"
export * from "./reportNoticeConfig.vue?vue&type=script&lang=js"
import style0 from "./reportNoticeConfig.vue?vue&type=style&index=0&id=700d23ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d23ce",
  null
  
)

export default component.exports